import { Box, Button, Card, Grid, Table, Tooltip } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCopy, IconPencil, IconPlus, IconTrash } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';
import copyText from '../../helpers/copyText';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import ConfirmationModal from '../Modals/ConfirmationModal';
import Spinner from '../Spinner';
import PartnerModal from './PartnersModal';

const SuperAdminPartners = () => {
  const fetch = useFetch();
  const [loadError, setLoadError] = useState();
  const [partners, setPartners] = useState();
  const [partner, setPartner] = useState();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(undefined);

  const loadPartners = useCallback(() => {
    setPartners(undefined);
    fetch('/api/admin/partners')
      .then(({ partners }) => {
        setPartners(partners);
      })
      .catch(setLoadError);
  }, [fetch]);

  const del = (id, cb) => {
    fetch(`/api/admin/partners/${id}`, { method: 'DELETE' })
      .then(() => {
        loadPartners();
        cb();
      })
      .catch(setLoadError);
  };

  useEffect(loadPartners, [loadPartners]);

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (partners === undefined) {
    return <Spinner />;
  }

  return (
    <>
      <Card withBorder>
        <Card.Section inheritPadding py="sm">
          <PartnerModal
            partner={partner}
            onClose={() => setPartner(undefined)}
            onSave={() => {
              notifications.show({
                title: 'Partner saved',
                message: 'Your changes have been saved successfully.',
                color: 'success',
              });
              loadPartners();
            }}
          />
          <ConfirmationModal
            show={!!confirmDeleteOpen}
            close={() => setConfirmDeleteOpen(undefined)}
            confirm={(cb) => del(confirmDeleteOpen, cb)}
            message="This action cannot be undone!"
          />
          {partners ? (
            <>
              <Table highlightOnHover>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Name</Table.Th>
                    <Table.Th>Token</Table.Th>
                    <Table.Th>Email</Table.Th>
                    <Table.Th>Phone Number</Table.Th>
                    <Table.Th>Billing</Table.Th>
                    <Table.Th></Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {partners.map((partner) => {
                    return (
                      <Table.Tr key={partner.id}>
                        <Table.Td>
                          <strong>{partner.name}</strong>
                        </Table.Td>
                        <Table.Td>
                          <span id={`p-${partner.id}-token`}>{partner.token}</span>{' '}
                          <Button variant="subtle" size="compact-xs" onClick={() => copyText(`p-${partner.id}-token`)}>
                            <IconCopy size={14} />
                          </Button>
                        </Table.Td>
                        <Table.Td>
                          <a href={`mailto:${partner.email}`}>{partner.email}</a>
                        </Table.Td>
                        <Table.Td>
                          <a href={`tel:${partner.phoneNumber}`}>{partner.phoneNumber}</a>
                        </Table.Td>
                        <Table.Td>{partner.billingManagement === 'internal' ? 'Releva' : 'Partner'}</Table.Td>

                        <Table.Td>
                          <Box style={{ float: 'right' }}>
                            <Tooltip label="Edit" position="top">
                              <Button size="sm" onClick={() => setPartner(partner)}>
                                <IconPencil size={14} />
                              </Button>
                            </Tooltip>
                            <Tooltip label="Delete" position="top">
                              <Button size="sm" ml="xs" color="red" onClick={() => setConfirmDeleteOpen(partner.id)}>
                                <IconTrash size={14} />
                              </Button>
                            </Tooltip>
                          </Box>
                        </Table.Td>
                      </Table.Tr>
                    );
                  })}
                </Table.Tbody>
              </Table>
              <Grid>
                <Grid.Col span={{ base: 12 }} ta="right">
                  <Button onClick={() => setPartner({ billingManagement: 'internal' })}>
                    <IconPlus size={14} /> Add Partner
                  </Button>
                </Grid.Col>
              </Grid>
            </>
          ) : (
            <Spinner />
          )}
        </Card.Section>
      </Card>
    </>
  );
};

export default SuperAdminPartners;
